/** @format */

import axios from "./axios";

export default {
    simOrder(param) {
        let method = "/front/sim/simOrder/create";
        return axios.post(method, JSON.stringify(param));
    },
    simOrderJd(param) {
        let method = "/front/sim/simOrder/jdCreate";
        return axios.post(method, JSON.stringify(param));
    },
    checkCanQueryOrder(param) {
        let method = "/front/sim/simOrder/checkCanQueryOrder";
        return axios.post(method, JSON.stringify(param));
    },
    checkOrderExist(param) {
        let method = "/front/sim/simOrder/checkOrderExist";
        return axios.post(method, JSON.stringify(param));
    },
    simViewLogAdd(param) {
        let method = "/front/sim/simViewLog/add";
        return axios.post(method, JSON.stringify(param));
    },
    numGuessSelect(param) {
        let method = "/front/gdlt/numGuessSelect";
        return axios.post(method, JSON.stringify(param));
    },
    ltZOPnumGuessSelect(param) {
        let method = "/front/ltzop/numGuessSelect";
        return axios.post(method, JSON.stringify(param));
    },
    ltZOPnumGuessSelect2(param) {
        let method = "/front/gzuni/numSelect";
        return axios.post(method, JSON.stringify(param));
    },
    simNumGuessSelect(param) {
        let method = "/front/sim/numSelect";
        return axios.post(method, JSON.stringify(param));
    },
    chongqingNumGuessSelect(param) {
        let method = "/front/chongqing/getNumber";
        return axios.post(method, JSON.stringify(param));
    },
    getProtocols(param) {
        let method = "/front/ltzop/getProtocols";
        return axios.post(method, JSON.stringify(param));
    },
    uploadUserInfo(param) {
        let method = "/front/sim/simRider/add ";
        return axios.post(method, JSON.stringify(param));
    },
    getOrderStatus(param) {
        let method = "/front/sim/simOrder/getOrderStatus";
        return axios.post(method, JSON.stringify(param));
    },
    getActivityBySpi(param) {
        let method = "/front/sim/simSpiActivity/getActivityBySpi";
        return axios.post(method, JSON.stringify(param));
    },
    //选择靓号
    bNumSelectNice(param) {
        let method = "/front/gzuni/numSelectNice";
        return axios.post(method, JSON.stringify(param));
    },
    //查询订单列表
    queryOrder(param) {
        let method = "/front/gztelecom/queryOrder";
        return axios.post(method, JSON.stringify(param));
    },
    //查询订单详情
    queryOrderByOrderNo(param) {
        let method = "/front/gztelecom/queryOrderByOrderNo";
        return axios.post(method, JSON.stringify(param));
    },
    //按系统订单id查询订单详情
    queryOrderByOrderId(param) {
        let method = "/front/gztelecom/queryOrderByOrderId";
        return axios.post(method, JSON.stringify(param));
    },
    //浙江下单地址 /front/telecom/externalLogin
    zhejiangExternalLogin(param) {
        let method = "/front/zhejiangtelecom/testexternalLogin/" + param.loginType;
        console.log("param=>", param);
        return axios.post(method, JSON.stringify(param));
    },
    zhenjiangQueryOrder(param) {
        let method = "/front/zhejiangtelecom/queryOrder";
        return axios.post(method, JSON.stringify(param));
    },
    queryDbOrder(param) {
        let method = "/front/sim/simOrderQuery/queryDbOrder";
        return axios.post(method, JSON.stringify(param));
    },
    checkElemeRiderActive(param) {
        let method = "/front/sim/simOrder/checkElemeRiderActive";
        return axios.post(method, JSON.stringify(param));
    },
    checkElemeRider(param) {
        let method = "/front/eleme/checkRider";
        return axios.post(method, JSON.stringify(param));
    },
    // 口令自助查询：姓名+身份证+手机号三要素
    queryRiderPwd(param) {
        let method = "/front/eleme/queryRiderPwd";
        return axios.post(method, JSON.stringify(param));
    }
};
